import styled from 'styled-components';

import { Flow } from 'components/common/flow';
import theme from 'utils/theme';

export const Tile = styled.article`
  a {
    display: block;
    color: inherit;

    > * + * {
      margin-top: var(--space-xs);
    }
  }

  ${Flow} {
    > * {
      display: block;
    }
  }
`;

export const TileTitle = styled.h3`
  margin: 0;
  font: inherit;
  font-weight: ${theme.weights.bold};
`;
